import { render, staticRenderFns } from "./LiteGames.vue?vue&type=template&id=167661ac&scoped=true"
import script from "./LiteGames.vue?vue&type=script&lang=ts"
export * from "./LiteGames.vue?vue&type=script&lang=ts"
import style0 from "./LiteGames.vue?vue&type=style&index=0&id=167661ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167661ac",
  null
  
)

export default component.exports